module.exports = ".cart_description {\n  padding-left: 15px !important;\n  padding-top: 0px !important; }\n\n.cart_quantity {\n  width: 150px;\n  padding-right: 5px;\n  padding-left: 5px; }\n\n.cart_total {\n  padding-top: 16px !important; }\n\n.cart_price {\n  padding-top: 16px !important; }\n\n.cart_delete {\n  padding-top: 20px; }\n\n.btn-default {\n  border-radius: 0px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/adminUser/myShopping/myShopping.scss
// module id = 565
// module chunks = 1